import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { adsListViews, adsTypes } from 'Core/constants'
import { debounce } from 'throttle-debounce'
import withTranslation from 'next-translate/withTranslation'
import StpdBannerComponent from 'stpd-ad-component'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { AdBreadcrumbs } from 'SRC/modules/ads/shared/components/AdBreadcrumbs'
import { getAds, getAdsLoading } from '../../selectors'
import { getPaginationParams } from '../../../pagination/selectors'
import { fetchAds, setLoading } from '../../actions'
import { Header, GridViewIcon, CardViewIcon } from '../Header'
import { GridViewList } from '../GridView'
import { CardViewList } from '../CardView'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { TextPreloader } from 'SRC/ui/Preloader'
import Router from 'next/router'
import { setAppInternalTransitionFunc } from 'SRC/modules/common/actions'
import { Panel } from '../Panel'
import { routes } from 'Core/routes'
import { SavedSearch } from '../../../filter/components'
import Link from 'next/link'
import TopLoader from 'react-top-loader'
import config from 'SRC/config/config.json'

const AfterAdsBanner = () => {
  return config.banners.adsList.afterAds ? (
    <div style={{ width: 640, height: 100 }}>
      <StpdBannerComponent
        refreshOnUrlChange={true}
        adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adsList.afterAds.adUnit}`}
        size={config.banners.adsList.afterAds.sizes}
        divId={config.banners.adsList.afterAds.slotId}
      />
    </div>
  ) : null
}

const MobileTopBanner = () => {
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    setWindowWidth(window.innerWidth)
    const handleWindowResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return config.banners.adsList.mobileTop ? (
    <div style={{ width: windowWidth <= 727 ? 320 : 728, margin: 'auto', position: 'relative' }}>
      <StpdBannerComponent
        refreshOnUrlChange={true}
        adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adsList.mobileTop.adUnit}`}
        size={config.banners.adsList.mobileTop.sizes}
        divId={config.banners.adsList.mobileTop.slotId}
      />
    </div>
  ) : null
}

export class List extends React.Component {
  constructor(props) {
    super(props)

    this.adsListViews = config.adsList.adsListViews

    this.tableRef = React.createRef()
    this.listRef = React.createRef()

    this.state = {
      style: this.adsListViews[Object.keys(this.adsListViews)[0]],
      isLoading: false,
      dfpRefreshCount: 0
    }

    if (Router.router) {
      Router.router.events.on('routeChangeStart', this.onRouteChangeStartHandler)
      Router.router.events.on('routeChangeComplete', this.onRouteChangeCompleteHandler)
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll)
    this.props.setAppInternalTransitionFunc(this.isInternalTransition)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll)
    this.props.setAppInternalTransitionFunc(null)
  }

  onRouteChangeStartHandler = url => {
    if (this.isInternalTransition(url)) {
      this.showSpinner()
    }
  }

  onRouteChangeCompleteHandler = (url) => {
    this.hideSpinner()
  }

  isInternalTransition = url =>
    /^\/naslovna\/.+$/.test(url) ||
    /^\/.+\/all\/\d+$/.test(url) ||
    /^\/.+\/pretraga/.test(url) ||
    /^\/$/.test(url) ||
    /^\/\?[A-Za-z0-9&=]*$/.test(url) ||
    /^\/.+\?[A-Za-z0-9&=]*$/.test(url) ||
    !routes.includes(url)

  showSpinner = () => {
    this.props.setLoading(true)
  }

  hideSpinner = () => {
    this.props.setLoading(false)
  }

  setTableView = () => {
    this.setState({ ...this.state, style: adsListViews.TABLE })
  }

  setListView = () => {
    this.setState({ ...this.state, style: adsListViews.LIST })
  }

  getIsScrolledToBottom = () => {
    const { style } = this.state

    let currentRef

    if (style === adsListViews.TABLE) currentRef = this.tableRef.current
    else currentRef = this.listRef.current

    const blockBorder = currentRef.scrollTop + currentRef.clientHeight
    const isScrolledToBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight

    return isScrolledToBottom || window.pageYOffset >= blockBorder / 2
  }

  handleScroll = () => {
    const { enabledInfiniteScroll, paginationParams, ads, isLoading, fetchAds } = this.props
    if (!enabledInfiniteScroll) return

    const isScrolledToBottom = this.getIsScrolledToBottom()

    if (isScrolledToBottom && !isLoading && ads.length < paginationParams.paidCount) {
      const loadOptions = {
        page: Number(paginationParams.currentPage) + 1,
        type: paginationParams.adsType,
        limit: paginationParams.countPerPage,
        status: 'Published',
        incrementCurrentPage: true,
        sortBy: 'dateDesc'
      }

      fetchAds(loadOptions, paginationParams, ads)
    }
  }

  render() {
    const { isMobileDevice, pageUrlItems, showBreadCrumbs, i18n: { t } } = this.props

    const title = this.props.isSearchPage
      ? `${t('common:PRONAĐENO')} ${this.props.paginationParams.totalCount} ${t('common:OGLASA')}`
      : this.props.title

    return (
      <div className='oglasi'>
        {isMobileDevice ? <MobileTopBanner /> : null}

        {/* <Header title={title} /> */}
        {!this.props.isUserSearch && showBreadCrumbs ? <AdBreadcrumbs pageUrlItems={pageUrlItems} /> : null}

        <div className='oglasi-filter clearfix'>
          {!isMobileDevice ? (
            <Panel
              currentPage={this.props.paginationParams.currentPage}
              filterValues={this.props.filterValues}
              formStyle={this.props.formStyle}
              isUserSearch={this.props.isUserSearch}
            />
          ) : null}
          {!isMobileDevice ? (
            <div className='oglasi-filter-grid'>
              <ul>
                {this.adsListViews.TABLE ? <GridViewIcon onClick={this.setTableView} style={this.state.style} /> : null}
                {this.adsListViews.LIST ? <CardViewIcon onClick={this.setListView} style={this.state.style} /> : null}
                <SavedSearch filterValues={this.props.filterValues} formStyle={this.props.formStyle} />
              </ul>
            </div>
          ) : null}
        </div>

        <div className='oglasi-content'>
          {this.adsListViews.TABLE ? (
            <GridViewList
              ads={this.props.ads}
              isLoading={this.props.isLoading}
              style={this.state.style}
              ref={this.tableRef}
              noAdsMessage={this.props.noAdsMessage}
            />
          ) : null}

          {this.adsListViews.LIST && !isMobileDevice ? (
            <CardViewList
              ads={this.props.ads}
              isLoading={this.props.isLoading}
              style={this.state.style}
              ref={this.listRef}
              noAdsMessage={this.props.noAdsMessage}
            />
          ) : null}

          {/* {this.props.isLoading ? <TextPreloader /> : null} */}

          {
            this.props.ads.length >= this.props.paginationParams.paidCount &&
              this.props.paginationParams.adsType === adsTypes.paid
              ? (
                <Link
                  href={{ pathname: '/', query: { page: 1, type: adsTypes.free } }}
                  as={`/naslovna/${adsTypes.free}/1`}
                >
                  {/* <button className='form-submit-btn'>Učitaj još oglasa</button> */}
                  <button className='form-submit-btn'>{t('common:load_more_ads')}</button>
                </Link>
              ) : null
          }

          {!isMobileDevice ? <AfterAdsBanner /> : null}
        </div>

        <TopLoader show={this.props.isLoading} className='top-loader' />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ads: getAds(state),
    isLoading: getAdsLoading(state),
    paginationParams: getPaginationParams(state),
    isMobileDevice: getIsMobileDevice(state)
  }
}

List.propTypes = {
  ads: PropTypes.array.isRequired,
  enabledInfiniteScroll: PropTypes.bool,
  fetchAds: PropTypes.func,
  paginationParams: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    countPerPage: PropTypes.number.isRequired,
    paidCount: PropTypes.number.isRequired,
    freeCount: PropTypes.number.isRequired,
    adsType: PropTypes.oneOf([
      adsTypes.paid,
      adsTypes.all,
      adsTypes.free
    ]).isRequired,
    totalCount: PropTypes.number.isRequired,
    paidAdsPage: PropTypes.number
  }).isRequired,
  noAdsMessage: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isSearchPage: PropTypes.bool,
  isUserSearch: PropTypes.bool,
  showBreadCrumbs: PropTypes.bool,
  isMobileDevice: PropTypes.bool.isRequired,
  title: PropTypes.string,
  pageUrlItems: PropTypes.object,
  setLoading: PropTypes.func.isRequired,
  setAppInternalTransitionFunc: PropTypes.func.isRequired
}

List.defaultProps = {
  ads: [],
  enabledInfiniteScroll: false,
  isSearchPage: false,
  isLoading: false,
  showBreadCrumbs: true
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, { fetchAds, setLoading, setAppInternalTransitionFunc })
)

export default enhance(List)
